import { render, staticRenderFns } from "./OnBoard.vue?vue&type=template&id=7ec3a543"
import script from "./OnBoard.vue?vue&type=script&lang=js"
export * from "./OnBoard.vue?vue&type=script&lang=js"
import style0 from "./OnBoard.vue?vue&type=style&index=0&id=7ec3a543&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports